export function isProdEnvironment():boolean {
    return document.getElementById('prod-environment') !== null;
}
export function isTrboJsEnabled():boolean {
    return document.getElementById('trbo-js-enabled') !== null;
}
